import { Keyboard } from 'types/keyboard'

import styles from './SheetOverlay.module.scss'

export function SheetOverlay({ onClose }: { onClose: () => void }) {
	return (
		<button
			onKeyDown={(e) => {
				if (
					e.key === Keyboard.Space ||
					e.key === Keyboard.Escape ||
					e.key === Keyboard.Enter
				) {
					onClose()
				}
			}}
			data-testid='sheet.overlay'
			className={styles.close}
			aria-label='close'
			onClick={onClose}
		>
			&times;
		</button>
	)
}
